// components/search/more/SearchSuggestionsSkeleton.tsx
import { Skeleton } from "@/app/components/shadcn/skeleton";

const SearchSuggestionsSkeleton = () => (
  <div className="space-y-3">
    {[1, 2].map((g) => (
      <div key={g}>
        <Skeleton className="h-3 w-24 mb-2 mx-2" />
        <div className="space-y-1">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="flex items-center justify-between px-2 py-2"
            >
              <div className="flex items-center gap-2">
                <Skeleton className="w-5 h-5 rounded" />
                <Skeleton className="h-3.5 w-40" />
              </div>
              <Skeleton className="h-4 w-12 rounded" />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default SearchSuggestionsSkeleton;
